/* src/app/password-change/password-change-presenter/password-change-presenter.component.scss */
.password-change-overlay {
  width: 100vw;
  height: 100vh;
  display: flex;
  z-index: 9998;
  top: 56px;
  left: 0px;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2862745098);
}
.full-width-message {
  width: 100%;
}
/*# sourceMappingURL=password-change-presenter.component.css.map */
